import { Lookup } from '../lookup.interface';

export const AuditTypes: { [name: string]: Lookup } = {
  intake: { code: 'intake', displayValue: 'Intake audit' },
  CM: { code: 'CM', displayValue: 'CM audit' },
};
